<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, getCurrentInstance } from "vue";
import { getSiteData, goBack } from "@/NavigationHelper";
import { Globals } from "@/Globals";
import {
  getKennungValueDisplay,
  getKennungTitle,
  getKennungValue,
} from "@/DataHelper";
import { showSnackbar } from "@/UIHelper";
import { globalsBegriffMemo, checkBegriff, globalsStt } from "@/local";
import { mountedBase, BaseSetup, onDelete, onSave } from "@/DataLoaderStatic";
const emit = defineEmits(["back", "update:modelValue"]);

let disabled = ref<boolean>(false);
let clearable = ref<boolean>(false);
let showVerbAuftrag = ref<boolean>(false);
let showTaetigkeit = ref<boolean>(false);
let showDeleteMask = ref<boolean>(false);
let stdVorschlag = ref<number>(0);
let stdAktuell = ref<number>(0);
let zulage = ref<string>("");
let auftrag = ref<string>("");
let taetigkeit = ref<string>("");
let kst = ref<string>("");
let endAuftrag: string = "";
let calcToday: boolean = false;
let editaic = ref<number>(0);

let zulagenErfassung = ref<boolean>(false);
const vueInstance = getCurrentInstance();

let gwsModul = ref<boolean>(false);
let showAuftrag = ref<boolean>(false);
let setKey = ref<number>(0);

function roundHours(value: number) {
  return Math.round(value * 100) / 100;
}

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_NewProjektstunden",
  emitBack: () => emit("back"),
};
const siteData = getSiteData();
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  if (checkBegriff("Web_New_LeistungserfassungGWS")) {
    pageParams.query = "Web_New_LeistungserfassungGWS";
    gwsModul.value = true;
    // pageParams.newData = true;
  }
  // von der VG Sicht wird der AIC mit übergeben
  if (siteData && siteData.stammAic) {
    editaic.value = siteData.stammAic;
  }
  // wenn EDIT aufegrufen wird - dann aic NICHT setzen - dann genügt BEw AIC!
  if (siteData && siteData.aic && !siteData.bewegungsdaten) {
    pageParams.aic = siteData.aic;
  }
  if (siteData?.query && siteData?.zulage) {
    // manuelle Zulagenerfassung -Kunde Grohag
    pageParams.query = siteData.query;
    zulagenErfassung.value = true;
  }
  await mountedBase(uiData, pageParams, false);

  if (siteData.stdUebergabe) {
    stdVorschlag.value = stdAktuell.value = roundHours(siteData.stdUebergabe);
  }
  if (checkBegriff("WEB_heute_Berechnen")) {
    calcToday = true;
  }
  if (!uiData.showLoading && uiData.data) {
    const row = uiData.data[0];
    if (siteData.showDelete) {
      showDeleteMask.value = siteData.showDelete;
      stdVorschlag.value = stdAktuell.value = roundHours(
        getKennungValue(row, "hours", uiData.columns),
      );
    }
    if (pageParams.bewegungsdaten) {
      auftrag.value = getKennungValueDisplay(
        row,
        "INSTRUCTION",
        uiData.columns,
      );
      if (auftrag.value) {
        showAuftrag.value = true;
      }
      taetigkeit.value = getKennungValueDisplay(
        row,
        "ACTIVITY",
        uiData.columns,
      );
      kst.value = getKennungValueDisplay(row, "COST_CENTRE", uiData.columns);
    }

    const auftragTitle = getKennungTitle("ENDKUNDENAUFTRAG", uiData.columns);
    if (auftragTitle) {
      showVerbAuftrag.value = true;
    }
    const taetigkeitTitle = getKennungTitle("ACTIVITY", uiData.columns);
    if (taetigkeitTitle) {
      showTaetigkeit.value = true;
    }
    if (zulagenErfassung.value) {
      const gueltigkeit = uiData.columns.find(
        (c: any) => c.kennung === "VALIDITY",
      );

      if (gueltigkeit) {
        uiData.data[0][gueltigkeit.name] = uiData.zeitbereich.von
          .toISOStringWithTZ()
          .substr(0, 10);
      }
      // unsichtbare BewBoolean-Spalten mit neuArt "Limit" (z.B. "Bezahlt"/PAYEDERF) immer mit TRUE speichern
      // uiData.columns
      //   .filter(
      //     (c: any) =>
      //       c.type === "checkBox" &&
      //       c.meta?.neuArt === "Limit" &&
      //       c.meta?.invisible,
      //   )
      //   .forEach((c: any) => {
      //     uiData.data[0][c.name] = true;
      //   });
    }
    if (!showDeleteMask.value) {
      setTimeout(() => {
        clearAndFocus();
      }, 200);
    }
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});

function clearAndFocus() {
  if (vueInstance) {
    let timepicker: any = vueInstance.proxy?.$refs.timeSpanPicker;
    if (timepicker) {
      if (timepicker.length && timepicker.length > 0) {
        timepicker = timepicker[0];
      }
      // call exposed focus() on EditTimePicker
      if (typeof timepicker.focus === "function") {
        timepicker.focus();
      }
    }
  }
}
async function bewSave() {
  if (
    ((gwsModul.value && taetigkeit.value) ||
      auftrag.value ||
      kst.value ||
      zulagenErfassung.value) &&
    stdAktuell.value
  ) {
    const d = new Date();
    const datumHeute = new Date(d.setHours(0, 0, 0, 0));
    if (pageParams.zeitbereich) {
      if (zulagenErfassung.value) {
        await onSave(
          uiData,
          pageParams,
          0,
          "",
          pageParams.zeitbereich,
          editaic.value,
        );
      } else {
        const vonZeitZone = pageParams.zeitbereich.von;
        const von = new Date(vonZeitZone.setHours(0, 0, 0, 0));
        // ab Version 2.02 soll auch auf Modul - heute berechnen - geprüft werden
        if (calcToday && datumHeute.valueOf() === von.valueOf()) {
          await onSave(
            uiData,
            pageParams,
            0,
            "Web_Zeit_Zulagenbuchung",
            pageParams.zeitbereich,
            editaic.value,
          );
        } else if (datumHeute.valueOf() !== von.valueOf()) {
          await onSave(
            uiData,
            pageParams,
            0,
            "Web_Zeit_Zulagenbuchung",
            pageParams.zeitbereich,
            editaic.value,
          );
        } else {
          await onSave(uiData, pageParams, 0, "");
        }
      }
    } else {
      await onSave(uiData, pageParams, 0, "");
    }
  } else {
    const meldung = globalsBegriffMemo(
      Globals.Begriff,
      "WEB_SpeichernNichtMoeglich",
      "Speichern kann nicht durchgeführt werden da Daten leer sind",
    );

    showSnackbar({
      text: meldung,
      color: "warning",
    });
  }
  goBack();
}
async function bewDelete() {
  if (uiData.data && uiData.data[0].aic_Bew_pool) {
    const d = new Date();
    const datumHeute = new Date(d.setHours(0, 0, 0, 0));
    if (pageParams.zeitbereich) {
      const vonZeitZone = pageParams.zeitbereich.von;
      const von = new Date(vonZeitZone.setHours(0, 0, 0, 0));
      if (calcToday && datumHeute.valueOf() === von.valueOf()) {
        await onSave(uiData, pageParams, 0, "Web_Zeit_Zulagenbuchung");
      } else if (datumHeute.valueOf() !== von.valueOf()) {
        await onDelete(
          uiData,
          pageParams,
          uiData.data[0].aic_Bew_pool,
          "Web_Zeit_Zulagenbuchung",
          pageParams.zeitbereich,
        );
      } else {
        await onDelete(
          uiData,
          pageParams,
          uiData.data[0].aic_Bew_pool,
          "",
          pageParams.zeitbereich,
        );
      }
    }
  }
  goBack();
}
function setTaetigkeit(data: any) {
  showAuftrag.value = false;
  if (data.aic) {
    const Stamm = globalsStt(Globals.Stt, 0, "TAETIGKEIT");
    AUApi.Current.setSyncStamm(Stamm.aic, data.aic);
    auftrag.value = "";
    showAuftrag.value = true;
    setKey.value += +1;
  }
}
</script>
<template>
  <v-sheet pa-0>
    <v-progress-linear
      :indeterminate="true"
      v-if="uiData.showLoading"
      color="dvhSlider"
    ></v-progress-linear>
    <v-card v-if="uiData.initialized">
      <v-card-title>
        <EditDatePicker
          v-if="zulagenErfassung"
          :readonly="true"
          :queryZeitbereich="pageParams.zeitbereich"
          kennung="VALIDITY"
        >
        </EditDatePicker>

        <EditTimePicker
          id="timeSpanPicker"
          v-model="stdAktuell"
          ref="timeSpanPicker"
          :autofocus="true"
          :disabled="disabled"
          kennung="hours"
          :maxHours="stdVorschlag"
          :initValue="stdAktuell"
      /></v-card-title>
      <v-card-text v-if="!gwsModul">
        <EditComboBox
          v-if="zulagenErfassung"
          :modelValue="zulage"
          @update:modelValue="zulage = $event"
          :disabled="disabled"
          kennung="Zulagenzuordng"
          :queryZeitbereich="pageParams.zeitbereich"
        />
        <EditComboBox
          :modelValue="auftrag"
          @update:modelValue="auftrag = $event"
          :disabled="disabled"
          kennung="INSTRUCTION"
          :queryZeitbereich="pageParams.zeitbereich"
        />

        <EditComboBox
          :modelValue="kst"
          @update:modelValue="kst = $event"
          :disabled="disabled"
          kennung="COST_CENTRE"
          :queryZeitbereich="pageParams.zeitbereich"
        />

        <EditComboBox
          v-if="showTaetigkeit"
          v-model="taetigkeit"
          :disabled="disabled"
          kennung="ACTIVITY"
          :queryZeitbereich="pageParams.zeitbereich"
        />

        <EditComboBox
          v-if="showVerbAuftrag"
          v-model="endAuftrag"
          :disabled="disabled"
          kennung="ENDKUNDENAUFTRAG"
          :queryZeitbereich="pageParams.zeitbereich"
        />

        <EditTextArea
          :clearable="clearable"
          kennung="MEMO"
          :disabled="disabled"
        />
      </v-card-text>
      <v-card-text v-if="gwsModul">
        <EditComboBox
          v-if="showTaetigkeit"
          :modelValue="taetigkeit"
          @update:modelValue="taetigkeit = $event"
          :disabled="disabled"
          kennung="ACTIVITY"
          :queryZeitbereich="pageParams.zeitbereich"
          @changeValue="setTaetigkeit"
        />
        <EditComboBox
          v-if="showAuftrag && uiData.initialized"
          v-model="auftrag"
          :disabled="disabled"
          kennung="INSTRUCTION"
          :queryZeitbereich="pageParams.zeitbereich"
          :key="setKey"
        />

        <EditTextArea
          :clearable="clearable"
          kennung="MEMO"
          :disabled="disabled"
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CommonBaseButtons
          :deleteVisible="showDeleteMask"
          :createVisible="false"
          :refreshVisible="false"
          :backVisible="false"
          :ignoreFunctions="true"
          :saveVisible="true"
          @save="bewSave"
          @delete="bewDelete"
        ></CommonBaseButtons>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>

<style scoped>
.dvhCol {
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
